module.exports = __webpack_public_path__ + "media/img/bg-movie-8d2232f28da8147202b8aad6b8af534b.png";